import { SHOPPING_GUIDE } from './metadata';

const useStepShopping = () => {
  return {
    data: SHOPPING_GUIDE,
  };
};

export default useStepShopping;
